/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import find from 'lodash/find'
import filter from 'lodash/filter'
import clone from 'lodash/clone'
import { v4 as uuidv4 } from 'uuid'

export default function MultiPick(props) {
    const {
        name,
        columns,
        currentSelection,
        zIndex = 1000,
        updatedSelection,
        // showValue will show the array of values
        showValues,
    } = props

    const parentRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [scrollTop, setScrollTop] = useState(0)

    useEffect(() => {
        if (isOpen) {
            // Massive hack to wait until box repaints
            setTimeout(() => {
                parentRef.current.scrollTop = Number(scrollTop)
            }, 25)
        }
    })

    const toggleIsOpen = () => {
        if (isOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }

    const handleCheckClick = (value) => {
        let tempValues = clone(currentSelection)

        const findValue = find(tempValues, (d) => {
            if (value.value) {
                return String(value.value) === String(d)
            }
            return String(value) === String(d)
        })
        if (findValue) {
            tempValues = filter(tempValues, (d) => {
                if (value.value) {
                    return String(value.value) !== String(d)
                }
                return String(d) !== String(value)
            })
            updatedSelection(tempValues)
        } else {
            tempValues.push(value.value ? value.value : value)
            updatedSelection(tempValues)
        }

        if (scrollTop != parentRef.current.scrollTop) {
            setScrollTop(parentRef.current.scrollTop)
        }
    }

    const id = uuidv4()

    return (
        <div
            key={`parent_${id}`}
            className="dropdown"
            onClick={(event) => {
                toggleIsOpen()
            }}
        >
            {/* Label */}
            <span
                key={`span_${id}`}
                className="ddl-label"
                style={{
                    color: currentSelection.length > 0 ? '#ef4c29' : '#666',
                }}
            >
                {showValues
                    ? currentSelection.length > 0
                        ? `${name} (${
                              currentSelection.length == 1
                                  ? currentSelection[0]
                                  : `${currentSelection[0]} + ${
                                        currentSelection.length - 1
                                    }`
                          })`
                        : `${name}`
                    : currentSelection.length > 0
                    ? `${name} (${currentSelection.length})`
                    : `${name}`}
            </span>
            <div key={`${id}_mp_div`} className="dropdown-arrow">
                ▾
            </div>
            {isOpen && columns ? (
                <div
                    ref={parentRef}
                    key={`${id}_mp_div_child`}
                    className="multipick"
                    style={{ zIndex }}
                >
                    {columns.map((column, key) => {
                        const isChecked = find(currentSelection, (value) => {
                            if (column.value) {
                                return value === column.value
                            }
                            return String(value) === String(column)
                        })

                        return (
                            <div
                                key={`div_${id}_${key}`}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    event.preventDefault()
                                    handleCheckClick(column)
                                }}
                            >
                                <input
                                    type="checkbox"
                                    key={`input_${id}_${key}`}
                                    name={column.value ? column.value : column}
                                    value={column.value ? column.value : column}
                                    checked={isChecked}
                                    onChange={(event) => {
                                        event.stopPropagation()
                                        event.preventDefault()
                                        setScrollTop(
                                            parentRef.current.scrollTop
                                        )
                                        handleCheckClick(column)
                                    }}
                                />
                                &nbsp;
                                <label key={`label_${id}_${key}`}>
                                    {column.name ? column.name : column}
                                </label>
                            </div>
                        )
                    })}
                </div>
            ) : null}
        </div>
    )
}
